<div class="accordion">
  <div class="accordion-header" (click)="toggle()">
    <div class="header-content">
      <ng-content select="[accordion-title]"></ng-content>
    </div>
    <span class="chevron" [ngClass]="{ open: isExpanded }">
      <i class="mdi mdi-chevron-down"></i>
    </span>
  </div>
  <div [ngClass]="{'underlining': showDivider && isExpanded}"></div>
  <div *ngIf="isExpanded" class="accordion-content">
    <ng-content select="[accordion-content]"></ng-content>
  </div>
</div>
